import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
import LoadScript from "react-load-script";
import axios from 'axios';
import { vantivUrl, appleId, merchantId } from '../../../util/apiUtil';
import { formatPhoneNumber } from "../../../util/helper";
import "./applepay.css";
import generateOrderId from '../../forms/CreditCardEprotect/generateOrderId';
import * as UTIL from '../../../util';
var orderId = generateOrderId();
var EProtect;

var cleanPhone = function cleanPhone(phone) {
  if (phone) return formatPhoneNumber(phone.replace(/^\+[0-9]/, ''));
  return phone;
};

var setApplePay = function setApplePay(props) {
  var merchantIdentifier = props.merchantIdentifier,
      setPayOrderPayload = props.setPayOrderPayload,
      _props$payForOrder = props.payForOrder,
      payForOrder = _props$payForOrder === void 0 ? function (payload) {
    console.log('payForOrder', payload);
  } : _props$payForOrder,
      tipAmount = props.tipAmount,
      check = props.check;

  if (!ApplePaySession) {
    return;
  }

  var paymentRequest = {
    currencyCode: 'USD',
    merchantId: merchantIdentifier,
    countryCode: 'US',
    total: {
      label: 'Cracker Barrel',
      amount: props.cost.Total,
      type: 'final'
    },
    requiredBillingContactFields: ['postalAddress', 'name', 'phone', 'email'],
    requiredShippingContactFields: [],
    supportedNetworks: ['amex', 'discover', 'masterCard', 'visa'],
    merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit']
  };
  var session = new ApplePaySession(3, paymentRequest);

  session.onvalidatemerchant = function (event) {
    // Validate the merchant with your server (not implemented here)
    // You would typically make a server request to validate the merchant
    // Use the event.validationURL to send a validation request
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var validationURL, requestData, response, merchantSession;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              validationURL = event.validationURL;
              requestData = {
                validationURL: validationURL,
                merchantIdentifer: merchantIdentifier,
                domain: window.location.hostname
              }; // Make a POST request to your server (for local testing, use https://localhost:7116/merchantValidation running the Apple Pay validation server)

              _context.next = 5;
              return fetch(UTIL.apiUtil.generateUrl('applepay', 'merchantValidation'), {
                method: 'POST',
                headers: UTIL.apiUtil.setHeaders(),
                body: JSON.stringify(requestData)
              });

            case 5:
              response = _context.sent;

              if (response.ok) {
                _context.next = 8;
                break;
              }

              throw new Error('Network response was not ok');

            case 8:
              _context.next = 10;
              return response.json();

            case 10:
              merchantSession = _context.sent;
              // Complete merchant validation
              session.completeMerchantValidation(merchantSession);
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.error('Failed to validate merchant:', _context.t0);
              session === null || session === void 0 ? void 0 : session.abort();

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }))();
  };

  session.oncancel = function () {
    console.log('Apple pay cancelled');
  };

  session.onpaymentauthorized = function (event) {
    console.log("PAYMENT AUTH", event); // const shipping = event.payment.billingContact;

    var billing = event.payment.billingContact;
    var payment = event.payment.token;
    var eProtectRequest = {
      "paypageId": "".concat(appleId.payPageId),
      "reportGroup": 'digital_store',
      "orderId": orderId,
      "id": "".concat(merchantId),
      "checkoutIdMode": false,
      "url": "".concat(vantivUrl),
      "applepay": {
        "data": payment.paymentData.data,
        "signature": payment.paymentData.signature,
        "version": payment.paymentData.version,
        "header": {
          "ephemeralPublicKey": payment.paymentData.header.ephemeralPublicKey,
          "publicKeyHash": payment.paymentData.header.publicKeyHash,
          "transactionId": payment.paymentData.header.transactionId
        }
      }
    };

    var submitAfterEprotect = function submitAfterEprotect(e) {
      var cardTypes = {
        "Mastercard": "MC",
        "Visa": "VISA",
        "AMEX": "AMEX",
        "AX": "AMEX",
        "Discover": "DISCOVER"
      };
      var appleInfo = {
        firstName: billing.givenName,
        lastName: billing.familyName,
        email: billing.emailAddress,
        phone: cleanPhone(billing === null || billing === void 0 ? void 0 : billing.phoneNumber),
        bin: e.bin,
        expDate: e.expDate,
        country: billing.countryCode,
        countryCode: billing.countryCode,
        paymentMethod: "apple",
        lastFour: e.lastFour,
        cardNumber: "************".concat(e.lastFour),
        cardtype: cardTypes[e.type] ? cardTypes[e.type] : e.type,
        wptokenizedpan: e.paypageRegistrationId,
        WPOrderId: orderId,
        entrymode: "E-COMM"
      };
      var payload = {
        Store: parseInt(check.Store.replace('CB', '')),
        OrderCode: check.OrderCode,
        OrderTotal: check.TotalToPay,
        Gratuity: tipAmount,
        Payments: [{
          TokenType: 'LVT',
          PaymentAmount: check.TotalToPay,
          AuthorizationToken: appleInfo.wptokenizedpan,
          CardBin: appleInfo.bin,
          CardType: appleInfo.cardtype,
          ExpiryDate: appleInfo.expDate,
          CardHolderName: appleInfo.firstName + ' ' + appleInfo.lastName,
          CardSuffix: appleInfo.lastFour,
          IsApplePay: true,
          OrderSource: 'applepay'
        }],
        CustomerEmail: appleInfo.email
      };
      payForOrder(payload);
      console.log("session.completePayment", appleInfo);
      var result = {
        "status": ApplePaySession.STATUS_SUCCESS
      };
      session.completePayment(result);
    };

    var onErrorAfterEprotect = function onErrorAfterEprotect(e) {
      console.log('eProtect error: ', e);
      var result = {
        "status": ApplePaySession.STATUS_FAILURE
      };
      session.completePayment(result);
    };

    var timeoutOnEprotect = function timeoutOnEprotect(e) {
      console.log('timeoutOnEprotect error: ', e);
      var result = {
        "status": ApplePaySession.STATUS_FAILURE
      };
      session.completePayment(result);
    };

    var eProtect = new EProtect(eProtectRequest);
    eProtect.sendToEprotect(eProtectRequest, [], submitAfterEprotect, onErrorAfterEprotect, timeoutOnEprotect, 15000);
  };

  session.begin();
};

var performValidation = function performValidation(url) {
  // const uso = window.location.hostname == "localhost" ? 'qa.crackerbarrel.com' : window.location.hostname
  var data = {
    ValidationUrl: url,
    Context: window.location.hostname
  }; // const applePayURL = UTIL.apiUtil.generateUrl('apple-pay-services', 'validate');

  var applePayURL = 'https://apple-pay-validation-dev.azurewebsites.net/api/Validate';
  return axios({
    method: 'post',
    // headers: UTIL.apiUtil.setHeaders(),
    headers: {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': 'a910fdc07d884464a914f48efd420c72',
      'Environment': appleId.tokenEnvironment
    },
    data: data,
    url: applePayURL
  });
};

var setEProtect = function setEProtect() {
  EProtect = typeof window !== 'undefined' ? window.eProtect : '';
};
/* eslint-disable no-useless-computed-key */


var ApplePayButton = function ApplePayButton(props) {
  console.log("ApplePayButton", props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadScript, {
    url: "".concat(vantivUrl, "/eProtect/eProtect-api3.js"),
    onLoad: setEProtect
  }), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setApplePay(props);
    },
    className: "apple-pay-button-with-text apple-pay-button-black-with-text"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, "Pay Now with Apple Pay"), /*#__PURE__*/React.createElement("span", {
    className: "logo"
  })));
};
/* eslint-enable no-useless-computed-key */


ApplePayButton.defaultProps = {
  theme: "dark",
  "aria-label": "Pay with Apple Pay",
  children: "Pay with"
};
export default ApplePayButton;